import { AvailabilityDisplayKind, CheckInDateStatus } from './types'

export const statusToDisplayKind = (status: CheckInDateStatus): AvailabilityDisplayKind => {
  switch (status) {
    case 'OK':
      return 'available'
    case '-':
      return 'contact'
    case 'NG':
      return 'sold_out'
    default:
      return 'unknown'
  }
}

export const monthPercentToDisplayKind = (percent: number | null): AvailabilityDisplayKind => {
  if (percent === null) return 'unknown'
  if (percent === 0) return 'sold_out'
  if (percent > 0 && percent <= 29) return 'limited'
  if (percent >= 30) return 'available'
  return 'unknown'
}
